import React, { useState, useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const cookieSeen = localStorage.getItem('cookieSeen');
    if (cookieSeen !== 'shown') {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieSeen', 'shown');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="position-fixed bottom-0 start-0 end-0 bg-dark p-3"
      style={{ zIndex: 1050 }}
    >
      <Container className="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <p className="mb-0 me-3">
          This website uses cookies to ensure you get the best experience. By
          continuing to use this site, you consent to the use of cookies.
        </p>
        <Button variant="primary" size="sm" onClick={handleAccept}>
          Accept
        </Button>
      </Container>
    </div>
  );
};

export default CookieBanner;